module.exports = ".sidebar-left-content,\n#quicknav {\n    height: 100%\n}\n\n.activate{\n    background-color: #5d67718c;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/side-bar/side-bar.component.css
// module id = ./src/app/shared/side-bar/side-bar.component.css
// module chunks = main